export var siblings = function (element) {
    var _a;
    var result = [];
    var sibling = (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.firstElementChild;
    while (sibling) {
        if (sibling !== element) {
            result.push(sibling);
        }
        sibling = sibling.nextElementSibling;
    }
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/siblings.js
// module id = 351
// module chunks = 93